import { render } from "./Facet.vue?vue&type=template&id=abb4f4ee&scoped=true"
import script from "./Facet.vue?vue&type=script&lang=js"
export * from "./Facet.vue?vue&type=script&lang=js"

import "./Facet.vue?vue&type=style&index=0&id=abb4f4ee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abb4f4ee"]])

export default __exports__